import * as types from './mutation-types'

let defaultObject = () => ({
  data: {
    language_id: '',
    group: '',
    key: '',
    value: ''
  }
})

export default {
  [types.SET_TRANSLATION] (state, payload) {
    if (payload === null) {
      payload = defaultObject()
    }
    state.translation = payload
  },
  [types.SET_TRANSLATIONS] (state, payload) {
    state.translations = payload.data
    // Laravel paginate() returns pagination info at root level
    state.pagination = {
      total: payload.total || 0,
      current_page: payload.current_page || 1,
      per_page: payload.per_page || 50,
      last_page: payload.last_page || 1
    }
  },
  [types.SET_GROUPS] (state, payload) {
    state.groups = payload
  }
}
